import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { Modal } from "ant-design-vue";
import { mapState } from "vuex";
export default {
  name: "design-top",
  i18n: require('../../design/design_i18n'),
  data: function data() {
    return {
      title: "",
      // 活动标题
      curPage: 'designCategory',
      // 当前页面

      // 下拉选项的公共样式配置
      selectStyle: {
        "text-align": "center"
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    formEdited: function formEdited(state) {
      return state.design.formEdited;
    }
  })), {}, {
    previewLink: function previewLink() {
      if (this.platform == 'pc') {
        return process.env.VUE_APP_API_PC_PREVIEW;
      } else {
        return process.env.VUE_APP_API_APP_PREVIEW;
      }
    }
  }),
  mounted: function mounted() {},
  methods: {
    handlePageChange: function handlePageChange(val) {
      if (val === 'designCategory') return;
      this.$router.push({
        path: '/design'
      });
    },
    handlePreviewClick: function handlePreviewClick() {
      this.$router.push({
        path: '/designCategory/preview'
      });
    },
    /**
     * 页面保存
     */
    handle_page_save: function handle_page_save() {
      var _this = this;
      if (!this.formEdited) return;
      this.$store.dispatch("design/page_save").then(function (res) {
        _this.$message.success('保存成功');
      }).catch(function (res) {
        console.log('res', res);
        _this.$message.error('保存失败');
      });
    },
    /**
     * 发布页面
     */
    handle_page_release: function handle_page_release() {
      var that = this;
      Modal.confirm({
        title: this.$t('header.surepublish'),
        onOk: function onOk() {
          that.$store.dispatch('design/page_publish');
        }
      });
    }
  }
};